import "core-js/modules/es6.string.ends-with";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import store from '@/store';
import { bizContext } from '@/utils/biz-context';
import { getCurrentBizCode } from '@/utils/routeHelper';

/**
 * 创建业务代码路由守卫
 * 用于处理路由中的业务代码参数
 */
export function createBizCodeGuard() {
  return function (to, from, next) {
    console.log("[BizCodeGuard] Entering guard for path: ".concat(to.path));

    // 如果路径中的 biz_code 是 :biz_code（未被替换），则替换为实际的业务代码
    if (to.params.biz_code === ':biz_code') {
      // 使用统一的业务代码获取逻辑
      var bizCode = getCurrentBizCode();
      if (!bizCode) {
        console.warn('[BizCodeGuard] No business code available');
        next('/404');
        return;
      }
      var realPath = to.path.replace('/biz/:biz_code', "/biz/".concat(bizCode));
      console.log("[BizCodeGuard] Redirecting to: ".concat(realPath));
      next({
        path: realPath,
        replace: true
      });
      return;
    }

    // 如果 URL 中的业务代码与 Store 中的不同，则更新 Store 和业务上下文
    if (to.params.biz_code && to.params.biz_code !== ':biz_code') {
      var _bizCode = to.params.biz_code;

      // 只有当业务代码真的变化时才进行更新
      if (_bizCode !== store.state.profile.currBizCode) {
        console.log("[BizCodeGuard] Business code changed: ".concat(store.state.profile.currBizCode, " -> ").concat(_bizCode));

        // 查找对应的业务信息
        var bizList = store.state.profile.bizList || [];
        var selectedBiz = bizList.find(function (biz) {
          return biz.code === _bizCode;
        });
        if (selectedBiz) {
          // 更新业务ID和业务代码
          store.commit('profile/SET_CURR_BIZ', selectedBiz.id);
          store.commit('profile/SET_CURR_BIZ_NAME', selectedBiz.name);
          store.commit('profile/SET_CURR_BIZ_CODE', selectedBiz.code);

          // 更新业务上下文
          if (bizContext) {
            bizContext.switchBiz(_bizCode);
          }

          // 更新 sessionStorage
          sessionStorage.setItem('currBiz', selectedBiz.id);
          sessionStorage.setItem('currBizCode', selectedBiz.code);
          sessionStorage.setItem('currBizName', selectedBiz.name);

          // 记录最后访问的业务代码
          localStorage.setItem('last_visited_biz', _bizCode);

          // 确保路由状态更新，保证导航栏能够正确展示
          var _require = require('@/router'),
            asyncRoutes = _require.asyncRoutes,
            constantRoutes = _require.constantRoutes;
          var allRoutes = [].concat(_toConsumableArray(constantRoutes), _toConsumableArray(asyncRoutes));
          store.commit('route/SET_ROUTES', allRoutes);
          store.commit('permission/SET_ROUTES', asyncRoutes);
          console.log("[BizCodeGuard] Business context updated to: ".concat(selectedBiz.name, "(").concat(selectedBiz.code, ")"));
        } else {
          console.warn("[BizCodeGuard] Business code ".concat(_bizCode, " not found in list"));
          next('/404');
          return;
        }
      } else {
        console.log("[BizCodeGuard] Business code unchanged: ".concat(_bizCode));
      }
    }

    // 验证业务权限 - 首页允许无权限访问
    if (to.params.biz_code && !(to.path.endsWith('/index') || to.path === '/')) {
      var userBizList = store.state.profile.bizList || [];
      var hasBizAccess = userBizList.some(function (biz) {
        return biz.code === to.params.biz_code;
      });
      if (!hasBizAccess) {
        console.warn("[BizCodeGuard] User has no access to business ".concat(to.params.biz_code));
        next('/404');
        return;
      }
    }
    next();
  };
}

/**
 * 创建业务代码重定向函数
 * 用于处理路由重定向时的业务代码参数
 */
export function createBizCodeRedirect() {
  return function (to) {
    // 动态重定向，保留路由参数中的业务代码
    var bizCode = to.params.biz_code;

    // 如果 biz_code 是 :biz_code（未被替换）或不存在，则使用统一的业务代码获取逻辑
    if (!bizCode || bizCode === ':biz_code') {
      bizCode = getCurrentBizCode();
      if (!bizCode) {
        console.warn('[BizCodeRedirect] No business code available');
        return '/404';
      }
    }
    console.log("[BizCodeRedirect] Redirecting to: /biz/".concat(bizCode, "/index"));
    return "/biz/".concat(bizCode, "/index");
  };
}